import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
} from '../../../data/common';
import { makeStrs, makeStrsSeperate } from '../../../lib/util';

function CTypeTestRow({ vocaList = {}, startNo, tab, config }) {
  // console.log('vocabList C:', vocaList);
  return (
    <div
      style={{
        width: '100%',
        marginTop: `${config?.spacing * Spacing_Base}px`,
      }}
    >
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: '700',
            fontFamily: "'Pretendard', Arial, sans-serif",
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions?.map((voca, idx) => {
          return (
            <div
              key={`${voca.questions}-${String(idx)}`}
              style={{
                marginTop: `${config?.spacing * Spacing_Base}px`,
                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                display: 'grid',
                fontFamily: "'Pretendard', Arial, sans-serif",
                gridTemplateColumns: '1.2fr 8.8fr',
                justifyContent: 'start',
                alignItems: 'start',
                width: '100%',
              }}
            >
              <div
                style={{
                  minWidth: '10px',
                  fontFamily: "'Pretendard', Arial, sans-serif",
                }}
              >
                {startNo + idx}.
              </div>
              <div>
                {(tab === PAPER_TABS.TEST_PAPER ||
                  tab === PAPER_TABS.ANSWER_TEST_PAPER) &&
                  voca?.questions?.map((subQuestion, eIndex) => {
                    return (
                      <div
                        key={`${subQuestion.answer}-${String(eIndex)}`}
                        style={{ marginBottom: '4px' }}
                      >
                        <div
                          style={{
                            minWidth: '100px',
                            marginBottom: '5px',
                            fontFamily: "'Pretendard', Arial, sans-serif",
                          }}
                        >
                          {subQuestion.questionTranslation}
                        </div>
                        <div
                          style={{
                            fontFamily: "'Pretendard', Arial, sans-serif",
                            display: 'flex',
                            justifyContent: 'start',
                            flexWrap: 'wrap',
                            gap: '3px',
                          }}
                        >
                          {tab === PAPER_TABS.TEST_PAPER &&
                            subQuestion.questionSentence
                              ?.split(/(\{[^{}]*\}|[^\s{}]+)/) // {} 내부와 외부를 구분하면서 split
                              .filter(Boolean) // 빈 문자열 제거
                              .map((word, idx) => {
                                return (
                                  <div
                                    key={`{${word.answer}-${String(idx)}}`}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-end',
                                      gap: '5px',
                                      flexWrap: 'wrap',
                                      fontFamily:
                                        "'Pretendard', Arial, sans-serif",
                                    }}
                                  >
                                    {word.startsWith('{') &&
                                    word.endsWith('}') ? (
                                      <>
                                        {/* new Array(makeStrs(word, PAPER_TABS.TEST_PAPER)).fill(0) */}
                                        {makeStrsSeperate(word)?.map(
                                          (sWord, idx) => {
                                            return (
                                              <div
                                                key={`${sWord}-${String(idx)}`}
                                                style={{
                                                  width: '80px',
                                                  minHeight: '15px',
                                                  borderBottom:
                                                    '1px solid #000',
                                                }}
                                              >
                                                {config?.vocaFirstWordShow
                                                  ? sWord[0]
                                                  : ''}
                                              </div>
                                            );
                                          },
                                        )}
                                      </>
                                    ) : (
                                      word
                                    )}
                                  </div>
                                );
                              })}
                          {tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                            subQuestion.questionSentence
                              ?.split(/(\{[^{}]*\}|[^\s{}]+)/) // {} 내부와 외부를 구분하면서 split
                              .filter(Boolean) // 빈 문자열 제거
                              .map((word, idx) => {
                                return (
                                  <div
                                    key={`{${word.answer}-${String(idx)}}`}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-start',
                                      gap: '5px',
                                      flexWrap: 'wrap',
                                      fontFamily:
                                        "'Pretendard', Arial, sans-serif",
                                    }}
                                  >
                                    {word.startsWith('{') &&
                                    word.endsWith('}') ? (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'flex-start',
                                          gap: '5px',
                                          flexWrap: 'wrap',
                                          fontFamily:
                                            "'Pretendard', Arial, sans-serif",
                                        }}
                                      >
                                        {makeStrs(word, PAPER_TABS.ANSWER).map(
                                          (str, idx) => {
                                            return (
                                              <div
                                                key={`${str}-${String(idx)}`}
                                                style={{
                                                  borderBottom:
                                                    '1px solid #000',
                                                  minHeight: '15px',
                                                  fontFamily:
                                                    "'Pretendard', Arial, sans-serif",
                                                }}
                                              >
                                                {str}
                                              </div>
                                            );
                                          },
                                        )}
                                      </div>
                                    ) : (
                                      <div>{word}</div>
                                    )}
                                  </div>
                                );
                              })}
                        </div>
                      </div>
                    );
                  })}
                {tab === PAPER_TABS.ANSWER && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '5px',
                      flexWrap: 'wrap',
                      fontFamily: "'Pretendard', Arial, sans-serif",
                    }}
                  >
                    {voca.word}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

CTypeTestRow.propTypes = {
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
};

export default CTypeTestRow;
